/**
 * @shoppex/contracts
 *
 * Shared TypeScript types generated from OpenAPI spec.
 * These types ensure type-safety between the Elysia API runtime and frontend apps.
 *
 * Usage:
 *   import { paths, components } from '@shoppex/contracts/api-types';
 *   import { createApiClient } from '@shoppex/contracts';
 */

import createClient from 'openapi-fetch';
import type { paths } from './api-types.js';

// Re-export generated types
export * from './api-types.js';
export * from './navigation.js';
export * from './observability.js';
export * from './email-marketing.js';
export * from './payment-gateways.js';
export * from './platform-billing.js';
export * from './style-center.js';
export * from './style-center/presets.js';
export * from './storefront-addons.js';
export * from './api-error-codes.js';
export * from './merchant-safe-errors.js';
export * from './manual-gateway-template.js';
export * from './external-payment-adapter.js';
export * from './redirect-link-template.js';
export * from './checkout-api.js';
export * from './invoice-wire.js';
export * from './developer-webhook.js';
export * from './catalog-unit-price.js';
export * from './customer-portal-wire.js';
export * from './type-assertions.js';
export * from './theme-ai-handoff.js';

/**
 * Create a type-safe API client
 *
 * @example
 * const client = createApiClient('https://api.shoppex.io/v1');
 *
 * // Fully typed request and response
 * const { data, error } = await client.GET('/products', {
 *   params: { query: { page: 1, limit: 25 } }
 * });
 */
export function createApiClient(baseUrl: string, token?: string) {
  return createClient<paths>({
    baseUrl,
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
}

// Common response types used across the app
export interface ApiResponse<T> {
  status: number;
  data: T | null;
  error: string | null;
  message: string | null;
  env: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    page: number;
    perPage: number;
    totalPages: number;
  };
}

export interface ApiError {
  status: number;
  error: string;
  message: string;
}
